import styled from "styled-components";

const PageWrapper = styled.div`
    background-color: #F7FAF2;
    width: 100%;
    min-height: 100vh;
    max-width: 1920px;
    margin: 0 auto;
`;

export default PageWrapper;
